import { Component } from '@angular/core';
import { PscCommonDialog } from '../../../../services/dialog/models/psc-common-dialog';
import { DialogService } from '../../../../services/dialog/dialog.service';
import { UnsubscribeOnDestroyAdapter } from '../../../adapters/unsubscibe-on-destroy.adapter';

@Component({
  selector: 'psc-confirm-dialog',
  templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent extends UnsubscribeOnDestroyAdapter {
  showConfirmDialog: boolean;
  confirmDialogObservable$ = this.dialogService.confirmDialogObservable$;
  confirmDialogModel: PscCommonDialog;

  constructor(
    public dialogService: DialogService,
  ) {
    super();
    this.subs.sink = this.confirmDialogObservable$.subscribe((dialogModel: PscCommonDialog) => {
      this.showConfirmDialog = true;
      this.confirmDialogModel = dialogModel;
    });
  }

  confirm() {
    this.showConfirmDialog = false;
    this.confirmDialogModel.onConfirm();
  }

  decline() {
    this.showConfirmDialog = false;
    if (this.confirmDialogModel.onDecline) {
      this.confirmDialogModel.onDecline();
    }
  }
}
